import React from 'react';
import Button from '../../components/button/button.jsx';
import Table from  '../../components/table/table.jsx';
import './productgallery.scss'


class ProductGallery extends React.Component {

	constructor(props){
		super(props);

		this.products = null;
		this.galleryAutoplayTimer = window.setTimeout(()=>{});

		this.initialState = {
			slides : null,
			slideState : 'in',
			activeSlide : 0,
			activeGalleryItem : 0,
			galleryAutoPlay : true
		}

		this.state = this.initialState;
	}

	componentDidMount(){
		window.addEventListener('Component.ProductGallery.Open', (e) => this.open(e.detail), false);
		window.addEventListener('Component.ProductGallery.Close', (e) => this.close(), false);
		window.addEventListener('Component.ProductGallery.Next', (e) => this.nextSlide(), false);
		window.addEventListener('Component.ProductGallery.Previous', (e) => this.previousSlide(), false);
	}

	render(){

		let currentSlide = this.state.slides ? this.state.slides[this.state.activeSlide] : null
		let currentProduct = currentSlide && currentSlide.product && this.products ? this.products[currentSlide.product] : null;

		return 	<section className="component productgallery" data-open={this.state.open} data-state={this.state.slideState}>
					<Button icon="close" className="close" clickEvent={'Component.ProductGallery.Close'}/>
					<Button icon="caret-left" className="previous" clickEvent={'Component.ProductGallery.Previous'}/>
					<Button icon="caret-right" className="next" clickEvent={'Component.ProductGallery.Next'}/>
					<div className="inner">
						{this.buildSlide(currentSlide)}
						{this.buildProduct(currentProduct)}
					</div>
				</section>
	}

	buildSlide(slide){
		if(!slide) return null;
			
		return  <article className="slide">
					<header className="header">
						{ slide.title && <h1> { slide.title } </h1> }
						{ slide.subtitle && <h2> { slide.subtitle } </h2> }
						{ slide.copy && <p dangerouslySetInnerHTML={{__html : slide.copy}}></p> }
						{ slide.table && <Table headers={slide.table.headers} rows={slide.table.content}/> }
					</header>

					<div className="gallery">
						<div className="items">
						
							{slide.items.map((item, i) => {
								return 	<div key={i} data-type={item.type} className="item" data-active={this.state.activeGalleryItem === i}>
											
											{item.type === 'youtube'
												? <iframe src={'https://www.youtube.com/embed/' + item.id + '?autoplay=1&showinfo=0&controls=0&rel=0&modestbranding=1'} title={i} frameBorder="0" allowFullScreen></iframe>
												: <img src={ item.url } alt={ item.url }/>
											}

										</div>
							})}
						</div>

						<div className="controls" data-count={slide.items.length}>
							{slide.items.map((item, i) => {
								return 	<i key={i} onClick={()=>{this.changeGalleryItem(i, true)}} data-active={this.state.activeGalleryItem === i}></i>
							})}
						</div>
					</div>
				</article>
	}

	buildProduct(product){
		if(!product) return null;

		return 	<article className="product">
					<img src={ product.image } alt={ product.title }/>
					{/*<header>
						<img src={ product.image } alt={ product.title }/>
					</header>*/}
					<div>
						<h2>{ product.subtitle }</h2>		
						<h1>{ product.title }</h1>
						<a href={ product.link } target="_blank">Learn More ></a>
					</div>
				</article>
	}

	changeGalleryItem(i, stoptimer){
		if(stoptimer === true) this.stopGalleryAutoplayTimer();
		this.setState({activeGalleryItem : i, galleryAutoPlay: false})
	}
	
	previousSlide(){
		this.changeSlide((this.state.activeSlide <= 0 ? this.state.slides.length - 1 : this.state.activeSlide - 1));
	}
	
	nextSlide(){
		this.changeSlide((this.state.activeSlide >= this.state.slides.length - 1 ? 0 : this.state.activeSlide + 1));
	}

	changeSlide(i){
		this.setState({slideState : 'out'}, ()=>{
			window.setTimeout(()=>{
				this.setState({activeSlide : i, slideState : 'in'}, ()=>{
					this.restartGalleryAutoplayTimer();
				})
			}, 500)	
		})
	}

	close(){
		if(this.state.open === false) return;

		this.stopGalleryAutoplayTimer();

		this.setState({open : false, galleryAutoPlay : false}, ()=>{
			window.setTimeout(()=>{
				window.dispatchEvent(new CustomEvent("Window.Scroll.Enabled"));
				this.setState({slides : null})
			}, 280)	
		})
	}

	open(data){

		if(this.state.open === true) return;
		
		// update products
		this.products = data.products;

		// set initial state		
		let initialState = this.initialState;
		initialState.slides = data.slides
		
		// load state
		this.setState(initialState, ()=>{
			window.dispatchEvent(new CustomEvent("Window.Scroll.Disabled"));
			this.setState({open : true}, ()=>{
				this.startGalleryAutoplayTimer()
			});
		})
	}
	
	restartGalleryAutoplayTimer(){
		clearTimeout(this.galleryAutoplayTimer)
		this.setState({galleryAutoPlay : false}, ()=>{
			this.startGalleryAutoplayTimer();
		})
	}

	startGalleryAutoplayTimer(){
		this.setState({galleryAutoPlay : true}, ()=>{
			this.galleryAutoplayTimer = setInterval(()=>{
				this.changeGalleryItem(this.state.activeGalleryItem >= this.state.slides[this.state.activeSlide].items.length - 1 ? 0 : this.state.activeGalleryItem + 1)
			}, 5000)
		})


	}

	stopGalleryAutoplayTimer(){
		clearTimeout(this.galleryAutoplayTimer);
		this.setState({galleryAutoPlay : false})
		
	}
}

export default ProductGallery;


// WEBPACK FOOTER //
// ./src/blocks/productgallery/productgallery.jsx